// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping Tenant component
 */
import { propTypes as MobxPropTypes } from 'mobx-react';
import React from 'react';
import DropDown from 'share/components/controls/Izenda.DropDown';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.MappingDetailActions';

const MappingTenant = (props: Object) => {
  const {
    localization,
    onChangeMappingTenant,
    store: {
      mappingTenants,
      databaseMappingDetail
    }
  } = props;
  return (
    <GridLayout className='izenda-MappingTenant'>
      <GridLayout.Row>
        <GridLayout.Col cols='1'>
          <label>
            {localization.getText('DATABASE_MAPPING_LABEL_MAPPING_DROPBOX')}
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='4'>
          <DropDown
            options={mappingTenants}
            onChange={onChangeMappingTenant}
            value={databaseMappingDetail.selectedTenantId}
            labelField='displayValue'
            valueField='id' />
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>
  );
};

MappingTenant.propTypes = {
  store: MobxPropTypes.observableObject
};

export default connect(actions)(MappingTenant);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/MappingDetail/Izenda.MappingTenant.js